import 'css-chunk:src/app/containers/Home/ApplicationsView/ApplicationsView.scss';export default {
  "ApplicationsView": "_ApplicationsView_5dfg7_1"
};